import React, { useLayoutEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import styles from './style.module.scss';
import { DragDropItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import InactiveIcon from '@components-clean/core/icons/inactive-icon/inactive-icon';
import Metadata from '@components-clean/core/metadata';

const DragDropItem = (props: DragDropItemProps) => {
    const {
        dataItem,
        selected,
        toDisplayColumn,
        inactiveIconTooltip,
        editButtonClick,
        draggable,
        applyCallOutClass,
        ...others
    } = props;

    const bodyContentRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState(0);

    const editButtonAction = (e: React.MouseEvent<HTMLButtonElement>) => {
        editButtonClick && editButtonClick(dataItem);
        e.stopPropagation();
    };

    useLayoutEffect(() => {
        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setContentHeight(bodyContentRef.current?.offsetHeight || 0);
    }, []);

    return (
        <li
            {...others}
            draggable={draggable as boolean}
            className={cn(
                [styles.triCustomListboxItem, 'k-flex-row', 'k-display-flex', 'k-flex-nowrap', '!k-p-0', '!k-gap-0'],
                { [styles.selected]: selected },
            )}
        >
            <div
                className={cn(
                    styles.triCustomListboxContent,
                    'k-display-flex',
                    'k-align-items-center',
                    'k-justify-content-between',
                    'k-w-full',
                )}
                ref={bodyContentRef}
            >
                <div className={cn([styles.trimPanelName, 'k-display-flex k-align-items-center k-pl-2'])}>
                    {(draggable as boolean) && (
                        <FontAwesomeIcon icon={['fas', 'grip-dots-vertical']} className="fa-lg mr-10" />
                    )}
                    <span>
                        <div className="k-py-1">{dataItem.title}</div>
                        {!!dataItem.subtitle && <div className="k-py-1">{dataItem.subtitle}</div>}
                    </span>
                </div>
                <div
                    className={cn('k-display-flex k-flex-row k-justify-content-center k-align-items-center k-h-full', {
                        [styles.rightRadius]: !(editButtonClick && (draggable as boolean)),
                    })}
                >
                    {dataItem?.active === false && toDisplayColumn && (
                        <div className={styles.inactiveIcon}>
                            <InactiveIcon
                                toolTipText={inactiveIconTooltip}
                                dataTestId="inactive-icon"
                                tooltipPosition="bottom"
                                className="k-mr-2"
                            />
                        </div>
                    )}
                    {dataItem.metadata && (
                        <div
                            className={cn('k-d-flex k-justify-content-center k-align-items-center k-h-full k-mr-2', {
                                [styles.listboxSecondary]: dataItem?.active === false && toDisplayColumn,
                                '!k-mr-0': dataItem?.active === false && toDisplayColumn,
                            })}
                        >
                            <Metadata
                                dataItem={dataItem.metadata}
                                position="top"
                                applyCallOutClass={applyCallOutClass}
                            />
                        </div>
                    )}
                </div>
            </div>
            {editButtonClick && (draggable as boolean) && (
                <button
                    type="button"
                    aria-label="edit-item"
                    onClick={editButtonAction}
                    className={styles.listboxSecondary}
                    style={{ height: contentHeight }}
                >
                    <FontAwesomeIcon icon={['fas', 'pencil']} style={{ width: 16, height: 16 }} />
                </button>
            )}
        </li>
    );
};

export default DragDropItem;
